// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2tk1Q","inputWrap":"styles_inputWrap__2343a","input":"styles_input__MGcyY"};